import { PropsWithChildren } from 'react';
import { DevPanelContext } from './DevPanelContext';
import { useDevPanel } from '../hooks/useDevPanel';
import { useIsDevPanelEnabled } from '../hooks/useIsDevPanelEnabled';

export const BaseDevPanelProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const dev = useDevPanel();

  return <DevPanelContext.Provider value={dev}>{children}</DevPanelContext.Provider>;
};

/**
 * DevPanelProvider is a wrapper component that provides the DevPanelContext to its children.
 *
 * NOTE: The context is only mounted if the dev panel is enabled.
 * @see useIsDevPanelEnabled
 */
export const DevPanelProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const isDevPanelEnabled = useIsDevPanelEnabled();

  if (!isDevPanelEnabled) {
    return <>{children}</>;
  }

  return <BaseDevPanelProvider>{children}</BaseDevPanelProvider>;
};
